import React from 'react';
import styled from "styled-components";

function Radio({label, name, id, value, className, checked, onChange}) {
    return (
        <div className={"custom-control custom-radio " + (className ? className : '')}>
            <Input type="radio" value={value} name={name} id={id} onChange={onChange} checked={checked ?? ''} className="custom-control-input"/>
            <Label className="d-flex align-items-center custom-control-label" htmlFor={id}>
                <span className="mr-16">{label}</span>
            </Label>
        </div>
    )
}

export default Radio;

const Label = styled.label`
    cursor: pointer;
    
    &:before, &:after {
        left: auto !important;
        right: 0;
    }
    
    &:before {
        top: 0 !important;
        position: relative !important;
        background-color: ${props => props.theme.white} !important;
    }
`;

const Input = styled.input`
    /*&:checked ~ ${Label}:after {
        background-color: ${props => props.theme.primary};
    }*/
`;